<template>
  <div>
    <section class="hero is-light is-bold">
      <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-end">
              <div class="tabs is-right">
                <ul>
                  <li>
                    <router-link :to="{ name: 'landing' }">Inicio</router-link>
                  </li>

                  <li class="is-active">
                    <router-link :to="{ name: 'contactenos' }"
                      >Contáctenos</router-link
                    >
                  </li>
                </ul>
                <span v-if="!isAuthenticated" class="navbar-item">
                  <router-link
                    :to="{ name: 'login' }"
                    class="button is-white is-outlined"
                    data-tooltip="Tooltip Text"
                  >
                    <i class="material-icons">person</i>&nbsp; Mi cuenta
                  </router-link>
                </span>
                <span v-if="!isAuthenticated" class="navbar-item">
                  <a
                    target="blank"
                    href="https://app.yungol.com"
                    class="button is-white is-outlined"
                    >Inicio yungol 1.0</a
                  >
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">Contáctenos</h1>
          <h2 class="subtitle is-3">
            Para nosotros será un gusto atender sus inquietudes.
          </h2>
        </div>
      </div>
    </section>
    <section class="section margin-top">
      <div class="container">
        <div class="field">
          <div class="control has-icons-left">
            <input
              class="input is-large"
              type="text"
              placeholder="Nombre"
              v-model="contacto.name"
            />
            <span class="icon is-medium is-left">
              <i class="material-icons">person</i>
            </span>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <input
              class="input is-large"
              type="email"
              placeholder="Correo"
              v-model="contacto.email"
            />
            <span class="icon is-medium is-left">
              <i class="material-icons">email</i>
            </span>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <textarea
              class="textarea is-large"
              placeholder="Mensaje"
              v-model="contacto.empresa"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <button
              class="button is-info is-large is-fullwidth"
              @click="enviar"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">También puedes escribirnos por whatsapp</h1>
          <h2 class="subtitle">Hola! Quiero concer mas sobre yungol</h2>
          <a
            href="https://api.whatsapp.com/send?phone=573157346304&text=Hola!%20Quiero%20conocer%20mas%20sobre%20yungol."
            target="blank"
            class="button is-fullwidth is-primary is-large"
            >Ir a Whatsapp</a
          >
        </div>
      </div>
    </section>
    <y-Footer></y-Footer>
  </div>
</template>

<script>
import yFooter from "@/components/core/Footer.vue";
import apiServices from "@/services/yungol-services-public";
import { mapState } from "vuex";
export default {
  data() {
    return {
      contacto: {
        name: "",
        empresa: "",
        email: "",
        telefono: "",
      },
    };
  },
  computed: {
    ...mapState(["isAuthenticated", "idtoken"]),
  },
  methods: {
    async enviar(tipo) {
      try {
        if (tipo === "contador") {
          this.contacto.empresa = "Contador";
          this.contacto.telefono = "N/A";
        }
        const result = await apiServices.post(`/contactus`, this.contacto);
        if (result.data) {
          this.$store.dispatch("notify", {
            message:
              "Mensaje enviado. Muy pronto un asesor lo estara contactando.",
          });
          this.contacto = {
            name: "",
            empresa: "",
            email: "",
            telefono: "",
          };
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  components: {
    yFooter,
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/components/core/Contactenos.vue